import { render, staticRenderFns } from "./RiskAssessmentTemplateNameHeader.vue?vue&type=template&id=11b6cdc6&scoped=true&"
import script from "./RiskAssessmentTemplateNameHeader.vue?vue&type=script&lang=ts&"
export * from "./RiskAssessmentTemplateNameHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RiskAssessmentTemplateNameHeader.vue?vue&type=style&index=0&id=11b6cdc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b6cdc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
